"use client";

import { useVenuePageTheme } from "../../hooks";
import VenueCarousel, { type VenueCarouselProps } from "./VenueCarousel";
import { useFeatureGate } from "statsig-react";
import { cn } from "@punchup/utils/cn";

type Props = Omit<VenueCarouselProps, "theme">;

export default function VenueCarouselThemed({
  venuePageSlug,
  shows,
  venueLogoImg,
}: Props) {
  const {
    accentColor,
    buttonLabelColor,
    topSectionBackgroundColor,
    logoImageBackgroundColor,
  } = useVenuePageTheme(venuePageSlug);

  // check here (rather than inside VenueCarousel)
  // to ensure black background with padding is hidden when gate is OFF
  if (!shows || shows.length === 0) return null;

  const theme =
    topSectionBackgroundColor ||
    buttonLabelColor ||
    accentColor ||
    logoImageBackgroundColor
      ? {
          backgroundColor: topSectionBackgroundColor,
          buttonLabelColor,
          buttonBackgroundColor: accentColor,
          placeholderBackgroundColor: logoImageBackgroundColor,
        }
      : undefined;

  return (
    <section
      className={cn("md:px-10 lg:px-[120px] pb-4 md:pb-6")}
      style={{
        backgroundColor: topSectionBackgroundColor,
      }}
    >
      <VenueCarousel
        venuePageSlug={venuePageSlug}
        venueLogoImg={venueLogoImg}
        theme={theme}
        shows={shows}
      />
    </section>
  );
}
